import React from "react";
import PropTypes from "prop-types";
import Select from "../select/Select";
import { findOptionByLabel, findOptionByValue } from "../select/utils";
import IconKeyboardArrowDown from "../icons/IconKeyboardArrowDown";
import IconKeyboardArrowUp from "../icons/IconKeyboardArrowUp";
import { Container } from "./styled/stream-cards-sort";

const items = [
  { value: "updated_at", label: "Recent Activity", dir: "desc" },
  { value: "name", label: "Title", dir: "asc" }
];
const labels = items.map((item) => item.label);

function StreamCardsSort({ sortTerm, sortStreams }) {
  const selectedItem = findOptionByValue(sortTerm, items);

  const handleChange = (sortValue) => {
    const option = findOptionByLabel(sortValue, items);
    sortStreams({ sortTerm: option.value, sortDir: option.dir });
  };

  return (
    <Container>
      <Select
        value={selectedItem.label}
        items={labels}
        closeArrow={<IconKeyboardArrowDown />}
        openArrow={<IconKeyboardArrowUp />}
        onChange={handleChange}
      />
    </Container>
  );
}

StreamCardsSort.propTypes = {
  sortTerm: PropTypes.string,
  sortStreams: PropTypes.func.isRequired
};

export default StreamCardsSort;
